module.exports = __webpack_public_path__ + "static/media/23000056_1638427459565772_506673542714432514_o-thumb.69d810f0.jpg";